import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SportScrollService {
  readonly filtersRequested = signal(false);
}
